import React, { useState } from 'react';
import { Check, ExternalLink, Plus } from 'lucide-react';
import { toast } from 'sonner';
import { STATUS_STYLE, errMsg, kApi } from '../../lib/karaokeApi';

export const StatusPill = ({ status, testId }) => {
  const [label, cls] = STATUS_STYLE[status] || STATUS_STYLE.waiting;
  return <span className={`text-[11px] font-bold px-2.5 py-1 rounded-full whitespace-nowrap ${cls}`} data-testid={testId}>{label}</span>;
};

// Guest requests grouped per guest; each song has its own + Add (DJ only).
export const RequestsPanel = ({ requests = [], canControl, onChanged }) => {
  const [busy, setBusy] = useState(null);
  const add = async (r, s) => {
    setBusy(`${r.id}-${s.idx}`);
    try { await kApi.add(r.id, s.idx); toast.success(`Added "${s.title || `Song ${s.idx}`}"`); onChanged(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  if (!requests.length) return <p className="text-sm text-slate-500 py-8 text-center" data-testid="karaoke-requests-empty">No requests yet. Guests scan the QR code to request songs.</p>;
  return (
    <div className="grid gap-3 md:grid-cols-2" data-testid="karaoke-requests">
      {[...requests].reverse().map((r) => (
        <div key={r.id} className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid={`karaoke-request-${r.id}`}>
          <div className="flex items-baseline justify-between gap-2">
            <p className="font-bold text-slate-900 break-words">{r.guest_name}</p>
            <p className="text-xs text-slate-500 shrink-0">Room {r.room_number} · {new Date(r.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}{r.via === 'staff' ? ' · by staff' : ''}</p>
          </div>
          {r.songs.map((s) => (
            <div key={s.idx} className="flex items-center gap-3" data-testid={`karaoke-request-song-${r.id}-${s.idx}`}>
              <span className="w-6 h-6 rounded-full bg-slate-900 text-white text-xs font-bold flex items-center justify-center shrink-0">{s.idx}</span>
              <img src={s.thumbnail} alt="" className="w-16 h-10 rounded-md object-cover shrink-0" />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-slate-800 break-words">{s.title || 'Untitled video'}</p>
                <a href={s.url} target="_blank" rel="noreferrer" className="text-xs text-sky-700 inline-flex items-center gap-1">YouTube <ExternalLink className="w-3 h-3" /></a>
              </div>
              <StatusPill status={s.status} testId={`karaoke-request-status-${r.id}-${s.idx}`} />
              {canControl && (s.status === 'waiting' ? (
                <button type="button" onClick={() => add(r, s)} disabled={busy === `${r.id}-${s.idx}`} className="h-10 px-3 rounded-xl bg-fuchsia-600 text-white text-sm font-semibold inline-flex items-center gap-1 shrink-0" data-testid={`karaoke-add-${r.id}-${s.idx}`}>
                  <Plus className="w-4 h-4" /> Add
                </button>
              ) : <Check className="w-5 h-5 text-emerald-600 shrink-0" />)}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default RequestsPanel;
